import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mind',
  templateUrl: './mind.component.html',
  styleUrls: ['./mind.component.css']
})
export class MindComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
